import Vue from "vue";
import VueRouter from "vue-router";
// 引入组件
// import home from "@/views/pc/home/index.vue"
// import about from "@/views/pc/about/index.vue"
// import product from "@/views/pc/product/index.vue"
// import develop from "@/views/pc/develop/index.vue"
// import contact from "@/views/pc/contact/index.vue"
// import rule from "@/views/pc/rule/sunshine.vue"
// import server from "@/views/pc/rule/server.vue"
// import privacy from "@/views/pc/rule/privacy.vue"
Vue.use(VueRouter)
//定义路由列表
const routes = [{
  path: "/",
  redirect: "/home"
},
  {
    path: "/home",
    component: () => import("@/views/pc/home/index.vue")
  },
  {
    path: "/about",
    component: () => import("@/views/pc/about/index.vue")
  },
  {
    path: "/product",
    component: () => import("@/views/pc/product/index.vue")
  },
  {
    path: "/LCDPanel",
    component: () => import("@/views/pc/product/LCDPanel.vue")
  },
  {
    path: "/CardManufacturing",
    component: () => import("@/views/pc/product/CardManufacturing.vue")
  },
  {
    path: "/develop",
    component: () => import("@/views/pc/develop/index.vue")
  }
  ,
  {
    path: "/contact",
    component: () => import("@/views/pc/contact/index.vue")
  }
  ,
  {
    path: "/rule",
    component: () => import("@/views/pc/rule/sunshine.vue")
  }
  ,
  {
    path: "/server",
    component: () => import("@/views/pc/rule/server.vue")
  },
  {
    path: "/privacy",
    component: () => import("@/views/pc/rule/privacy.vue")
  },
  /*{
    path: "/m/home",
    component: () => import("@/views/wap/home/index.vue")
  },
  {
    path: "/m/about",
    component: () => import("@/views/wap/about/index.vue")
  }
    ,
  {
    path: "/m/product",
    component: () => import("@/views/wap/product/index.vue")
  },
  {
    path: "/m/develop",
    component: () => import("@/views/wap/develop/index.vue")
  },
  {
    path: "/m/contact",
    component: () => import("@/views/wap/contact/index.vue")
  },
  {
    path: "/m/rule",
    component: () => import("@/views/wap/rule/sunshine.vue")
  }
    ,
  {
    path: "/m/server",
    component: () => import("@/views/wap/rule/server.vue")
  },
  {
    path: "/m/privacy",
    component: () => import("@/views/wap/rule/privacy.vue")
  }*/
]
//登录状态判定
// const _token = getStroage('access_token')
// if (_token) {
//   setStroage('access_token', _token)
// } else {
//   // window.location.href = setting.siteDomain + '/register.html?type=login&code=' + setting.appId
// }

var router = new VueRouter({
  routes
})
export default router;
